import httpRequest from "utils/httpRequest";

const URL = "/api";

export const searchHighway = async (keyword) => {
  const requestBody = {
    keyword,
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/highway/search`,
      requestBody
    );

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
